import React from 'react';
import styled from 'styled-components';
import { AiOutlineCopyrightCircle } from "react-icons/ai";

const DownFooter = () => {
  return (
    <OuterWrapper>
      <Wrapper>
        <div className='horizontal-line'></div>

        <div className='text-footer'>
          <div className='about-company'>
            <div className='Rights-Reserved'>
              <AiOutlineCopyrightCircle className='circle' />
              <p>2025</p>
              <p>-</p>
              <p className='highlight'>BAKPOKET</p>
              <p>All Rights Reserved</p>
            </div>
            <p className='line'>|</p>
            <div className='Initiation'>
              <p>An Initiative of Kredas IT & ITES India Pvt. Ltd.</p>
            </div>
          </div>

          <div>
            <p className='about-company1'>
              Powered by <a target='_blank' href='https://www.kredasit.com/'>www.Kredasit.com</a>
            </p>
          </div>
        </div>
      </Wrapper>
    </OuterWrapper>
  );
};

export default DownFooter;

const OuterWrapper = styled.section`
  background-color: #2a4157;
  padding: 6px 16px;
  display: flex;
  justify-content: center;

  @media (max-width: 480px) {
    padding: 0 16px;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1280px;

  .horizontal-line {
    width: 100%;
    height: 1px;
    background-color: #ef4766;
  }

  .text-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    flex-wrap: wrap;
    gap: 10px;
  }

  .about-company {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .Rights-Reserved {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
  }

  .circle {
    font-size: 16px;
    color: #ddd9d9;
  }

  .highlight {
    color: #ef4766;
  }

  .line {
    color: rgb(26, 224, 238);
    font-weight: bold;
  }

  .Initiation p {
    margin: 0;
  }

  .about-company1 {
    color: #ddd9d9;
    font-size: 14px;
    text-align: center;
  }

  a {
    color: rgb(26, 224, 238);
    text-decoration: none;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #ddd9d9;
  }

  @media (max-width: 768px) {
    .text-footer {
      flex-direction: column;
      align-items: center;
      text-align: center;
      line-height: 4px;
    }

    .about-company {
      justify-content: center;
      font-size: 12px;
    }

    .about-company1 {
      font-size: 11px;
    }

    .circle {
      font-size: 12px;
    }

    a {
      font-size: 11px;
    }

    p {
      font-size: 11px;
    }
  }

  @media (max-width: 480px) {
    .line {
        display:none;
    }
    .about-company {
      font-size: 10px;
      line-height: 4px;
    }

    .about-company1 {
      font-size: 10px;
    }

    a {
      font-size: 10px;
    }

    p {
      font-size: 10px;
    }

    .circle {
      font-size: 10px;
    }
  }
`;


// import React from 'react';
// import styled from 'styled-components';
// import { AiOutlineCopyrightCircle } from "react-icons/ai";

// const DownFooter = () => {
//   return (
//     <OuterWrapper>
//       <Wrapper>
//         <div className='horizontal-line'></div>

//         <div className='text-footer'>
//           <div className='about-company'>
//             <div className='Rights-Reserved'>
//               <AiOutlineCopyrightCircle className='circle' />
//               <p>2025</p>
//               <p>-</p>
//               <p className='highlight'>BAKPOKET</p>
//               <p>All Rights Reserved</p>
//             </div>
//             <p className='line'>|</p>
//             <div className='Initiation'>
//               <p>An Initiative of Kredas IT & ITES India Pvt. Ltd.</p>
//             </div>
//           </div>

//           <div>
//             <p className='about-company1'>
//               Powered by <a target='_blank' href='https://www.kredasit.com/'>www.Kredasit.com</a>
//             </p>
//           </div>
//         </div>
//       </Wrapper>
//     </OuterWrapper>
//   );
// };

// export default DownFooter;

// const OuterWrapper = styled.section`
//   // background-color: #2a4157;
//   padding: 6px 16px;
//   display: flex;
//   justify-content: center;

//   @media (max-width: 480px) {
//     padding: 0 16px;
//   }
// `;

// const Wrapper = styled.div`
//   width: 100%;
//   max-width: 1280px;

//   .horizontal-line {
//     width: 100%;
//     height: 1px;
//     background-color: #ef4766;
//     // background-color: #2a4157;
//   }

//   .text-footer {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 12px 0;
//     flex-wrap: wrap;
//     gap: 10px;
//   }

//   .about-company {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     flex-wrap: wrap;
//   }

//   .Rights-Reserved {
//     display: flex;
//     align-items: center;
//     gap: 5px;
//     flex-wrap: wrap;
//   }

//   .circle {
//     font-size: 16px;
//     color: #2a4157;
//   }

//   .highlight {
//     color: #ef4766;
//   }

//   .line {
//     color: rgb(26, 224, 238);
//     font-weight: bold;
//   }

//   .Initiation p {
//     margin: 0;
//   }

//   .about-company1 {
//     color: #2a4157;
//     font-size: 14px;
//     text-align: center;
//   }

//   a {
//     color: rgb(26, 224, 238);
//     text-decoration: none;
//   }

//   p {
//     margin: 0;
//     font-size: 14px;
//     color: #2a4157;
//   }

//   @media (max-width: 768px) {
//     .text-footer {
//       flex-direction: column;
//       align-items: center;
//       text-align: center;
//       line-height: 4px;
//     }

//     .about-company {
//       justify-content: center;
//       font-size: 12px;
//     }

//     .about-company1 {
//       font-size: 11px;
//     }

//     .circle {
//       font-size: 12px;
//     }

//     a {
//       font-size: 11px;
//     }

//     p {
//       font-size: 11px;
//     }
//   }

//   @media (max-width: 480px) {
//     .line {
//         display:none;
//     }
//     .about-company {
//       font-size: 10px;
//       line-height: 4px;
//     }

//     .about-company1 {
//       font-size: 10px;
//     }

//     a {
//       font-size: 10px;
//     }

//     p {
//       font-size: 10px;
//     }

//     .circle {
//       font-size: 10px;
//     }
//   }
// `;
